<template>
    <div id="geo-field-section">
      <div id="geo-container-section">
        <BaseFCPGeoLocator :id="`geo-coder`" label="near" :initialValue="initialValue" v-on:selected="onSelected" v-on:inputchange="onInput" helpText="ZIP or City, State" :required="true" :showOptionalLabel="false"/>
      </div>
    </div>
</template>
  
<script setup>

    const { reverseGeoLocate } = useGeolocation()
    const initialValue = ref('hello')
    const { criteriaContext, profile, hospAffContext, searchCriteriaPlaceName, mapboxToken } = useFCPModel()


    const isValidZipCode = (text) => {
        console.log("Testing isValidZip", text)
        var regex = /^\d{5}(-\d{4})?$/;
        return regex.test(text);
    }

    /**
     * If the user is authenticated and has a profile, we will automatically do a geoLocation lookup on the server based upon their zip code
     * to populate the latitude and longitude on the context. ( latLong field ).  Instead of just showing the zip code in the autocomplete field
     * we will do a reverse geoLocation on the latitude and longitude obtained on the server and display the address as it would be displayed if
     * it had been selected in the autocomplete.  This will make the behavior consistent. 
     */
    const calculateInitialvalue = async () => {

        if ( isValidZipCode(profile.value.initialZipCode) && criteriaContext.value.latLong) {

            const latLongSplit = criteriaContext.value.latLong.split(",")
            const lat = latLongSplit[0]
            const long = latLongSplit[1]
            const result = await reverseGeoLocate(lat, long, mapboxToken.value)
            initialValue.value = result.features[1].place_name
        }
        else {
            initialValue.value = ''
        }
    }

    await calculateInitialvalue()

    const onSelected = (event) => {
        if ( event ) {
            searchCriteriaPlaceName.value = event.name
            criteriaContext.value.latLong = `${event.latitude},${event.longitude}`
            criteriaContext.value.where = event.name
            hospAffContext.value.latitude = event.latitude
            hospAffContext.value.longitude = event.longitude
            hospAffContext.value.zip = event.zip
        }
    }

    //Listen for changes on the input field of the geocoder.  If it changes, clear out the latLong.  The user must select a new
    //entry from the list, otherwise they can type something in the field and hit search thinking they have a new search such as a new
    //zip code.  In reality, they would be seeing the resuults from the latLong from the previous search.  To prevent this, clear out
    //the latLong anytime the user types into the input field.  When an entry is selected from the list, a new latLong will be applied.
    const onInput = () => {
        criteriaContext.value.latLong = ''
    }
  
</script>